import { IDropdownStyles } from "@fluentui/react/lib/Dropdown";
import {
  DefaultPalette,
  FontWeights,
  getTheme,
  IDatePickerStyles,
  IIconProps,
  IMessageBarStyles,
  mergeStyles,
  mergeStyleSets,
} from "@fluentui/react";
import { Depths } from "@uifabric/fluent-theme";

const theme = getTheme();

export const fullLengthDropdownStyles: Partial<IDropdownStyles> = {
  root: { width: "100%" },
  dropdown: { width: "100%" },
};

export const fullLengthDatePicker: Partial<IDatePickerStyles> = {
  root: { width: "100%" },
  textField: { width: "100%" },
  callout: { width: "100%" },
};

export const colourDefault = {
  color: DefaultPalette.themePrimary,
};

export const colourGrey = {
  color: DefaultPalette.blackTranslucent40,
};
export const colourBlack = {
  color: DefaultPalette.black,
};
export const colourRed = {
  color: DefaultPalette.redDark,
};

export const hiddenStyle = {
  display: "none",
};

export const messageBarStyles: IMessageBarStyles = {
  iconContainer: {
    display: "none",
  },
  root: {
    margin: "5px auto",
  },
};

export const dropdownStyles: Partial<IDropdownStyles> = {
  dropdown: {
    maxHeight: 300,
  },
  dropdownItemsWrapper: { maxHeight: 200 },
};

export const contentStyles = (
  dialogWidth: number = 600,
  height?: number | string,
  fixedFooter?: boolean
) => {
  return mergeStyleSets({
    container: {
      width: "100%",
      padding: 20,
        paddingBottom: 0,
      borderTop: `4px solid ${theme.palette.themePrimary}`,
      // height: height ? height : "100%",
      // maxHeight: height ? height : "100%",
    },
    header: {
      flex: "1 1 auto",
      borderTop: `4px solid ${theme.palette.themePrimary}`,
      color: theme.palette.neutralPrimary,
      display: "flex",
      alignItems: "center",
      fontWeight: FontWeights.semibold,
      // padding: "20px 30px",
      position: "fixed",
      backgroundColor: "white",
      zIndex: 10,
    },
      imageContainer: {
          display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: 40, paddingBottom: 40
      },

    body: {
      paddingLeft: 30,
      paddingRight: 30,
      // paddingTop: 100,
      //height: height ? `calc(${height} - 200px)` : "calc(100vh - 200px)",
       height: '100%',
      // width: dialogWidth - 60,
      overflow: "hidden",
      // selectors: {
      //   p: { margin: "14px 0" },
      //   "p:first-child": { marginTop: 0 },
      //   "p:last-child": { marginBottom: 0 },
      // },
    },
      image: {
          // flex: 1,
          height: 1500,
          width: 2000,
          backgroundImage: `url('https://via.placeholder.com/1800x1300.png')`,
          backgroundSize: "contain",
      }
  });
};

export const iconButtonStyles = {
  root: {
    color: theme.palette.neutralPrimary,
    marginLeft: "auto",
    marginTop: "4px",
    marginRight: "2px",
  },
  rootHovered: {
    color: theme.palette.neutralDark,
  },
};

export const cancelIcon: IIconProps = { iconName: "Cancel" };

export const searchStyle = (marginTop?: number | string) => {
  return mergeStyles({
    marginLeft: 30,
    marginTop: marginTop ? marginTop : 30,
    width: 200,
    color: DefaultPalette.black,
  });
};

export const cellLineHeight = 35;

export const windowStyle = {
  paddingLeft: 25,
  paddingRight: 25,
  backgroundColor: "white",
  boxShadow: Depths.depth8,
};

export const notificationColors = {
  backgroundColor: "#deecf9",
  color: DefaultPalette.themePrimary,
};

export const badgeContainer = mergeStyles({
  display: "flex",
  flexDirection: "row",
  fontSize: 13,
  width: "100%",
  cursor: "pointer",
});
export const badgeCircle = mergeStyles({
  width: 20,
  minWidth: 20,
  height: 20,
  borderRadius: "50%",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: DefaultPalette.white,
  padding: 1,
  marginRight: 5,
});

export const badgeStandard = {
  backgroundColor: DefaultPalette.themePrimary,
};

export const badgeGrey = {
  backgroundColor: DefaultPalette.blackTranslucent40,
};
export const badgeBlack = {
  backgroundColor: DefaultPalette.black,
};
export const badgeRed = {
  backgroundColor: DefaultPalette.redDark,
};

export const badgeBlackEmpty = {
  color: DefaultPalette.black,
  borderColor: DefaultPalette.black,
  borderWidth: 1,
  borderStyle: "solid",
};

// FILTER PANEL

export const filterPanelStyles = (
  dialogWidth: number = 600,
  height?: number | string,
  fixedFooter?: boolean
) => {
  return mergeStyleSets({
    // container: {
    //   width: dialogWidth,
    //   height: height ? height : "100%",
    //   maxHeight: height ? height : "100%",
    // },
    header: {
      flex: "1 1 auto",
      borderTop: `4px solid ${theme.palette.themePrimary}`,
      color: theme.palette.neutralPrimary,
      display: "flex",
      alignItems: "center",
      fontWeight: FontWeights.semibold,
      padding: "20px 30px",
      position: "fixed",
      backgroundColor: "white",
      zIndex: 10,
      boxShadow: Depths.depth8,
      width: 584,
      // width: "100%",
      // width: dialogWidth - 60,
    },
    content: {
      paddingTop: 100,
      paddingLeft: 20,
      paddingRight: 20,
    },
    footer: {
      bottom: 0,
      right: 0,
      alignItems: "center",
      fontWeight: FontWeights.semibold,
      padding: "20px 30px",
      position: "fixed",
      backgroundColor: "white",
      zIndex: 10,
      boxShadow: Depths.depth8,
      width: 584,
      // width: dialogWidth - 60,
    },
  });
};
